"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowser = exports.detectCDN = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _config = require("../config");

var detectCDN = function detectCDN(url) {
  var _list$find;

  var list = Object.entries(_config.cdnConfigs).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return {
      key: key,
      host: value.host
    };
  });
  var key = list === null || list === void 0 ? void 0 : (_list$find = list.find(function (item) {
    return url.includes(item.host);
  })) === null || _list$find === void 0 ? void 0 : _list$find.key;
  return key;
};

exports.detectCDN = detectCDN;
var isBrowser = new Function('try {return this===window;}catch(e){ return false;}');
exports.isBrowser = isBrowser;